/*
 * This file resolves urls in regards to hybris' URL encoding logic.
 *
 * It's possible to configure hybris so that certain values, like language, shop id and price
 * are part of the url.
 *
 * These values are NOT sent in the urls from hybris and need to be manually added to every single
 * relative url.
 *
 * Because of that, all urls should be processed by either resolveUrl or resolveApiUrl before using
 *
 */

let contextPath = (() => {
  let val = window.SCHA?.urls?.contextPath ?? "";
  if (val === "/") {
    val = "";
  }
  return val;
})();

export const updateContextPathLanguage = (oldLanguage: string, newLanguage: string) => {
  contextPath = contextPath.replace(new RegExp(oldLanguage + "\\b"), newLanguage);
};

export function constructUrl(baseUrl: string, params: URLSearchParams) {
  const p = params.toString();
  if (!p) {
    return baseUrl;
  }
  const joinChar = p.includes("?") ? "&" : "?";
  return baseUrl + joinChar + p;
}

/**
 * Based on resolveURL from org.apache.taglibs.standard.tag.common.core.UrlSupport
 * @param url
 */
export function resolveUrl(url: string) {
  if (!url) {
    return "";
  }

  if (url.startsWith("//" + window.location.host)) {
    url = url.replace("//" + window.location.host, "/" + window.location.host + contextPath);
    return url;
  }
  if (isAbsoluteUrl(url) || !contextPath || url.startsWith("#")) {
    return url;
  }
  if (import.meta.env.DEV) {
    if (!url.startsWith("/")) {
      console.warn(`Not supported kind of relative link: ${url}`);
    }
  }

  return url.startsWith(contextPath) ? url : contextPath + url;
}

export const resolveApiUrl = resolveUrl;

const cacheBuster = window.SCHA?.config?.cacheBuster || 1;

/**
 * Keeping for possible future use
 * @param url
 */
export function resolveResourceURl(url: string) {
  if (isAbsoluteUrl(url)) {
    const param = `${url.endsWith("?") ? "&" : "?"}v=${cacheBuster}`;
    return url + param;
  }
  if (import.meta.env.DEV) {
    if (!url.startsWith("/")) {
      console.warn(`Not supported kind of relative link: ${url}`);
    }
  }

  return `/_ui/responsive/theme-alpha${url}`;
}

export function resolveCdnImageURL(filename: string) {
  return "https://cdn.schaeffler-ecommerce.com/ecom/images/" + filename;
}

/*
 * https://tools.ietf.org/html/rfc3986#section-4.3
 * absolute-URI  = scheme ":" hier-part [ "?" query ]
 * https://tools.ietf.org/html/rfc3986#section-3.1
 * scheme      = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
 */
const EXPR = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

function isAbsoluteUrl(url: string) {
  return EXPR.test(url);
}
